import { PropsWithChildren } from 'react';
import styles from './Dashboard.module.scss';

export function Dashboard({ children }: PropsWithChildren) {
  return <article className={styles.container}>{children}</article>;
}

export default Dashboard;
